import { TranslateService } from '@ngx-translate/core'
import { Component, Input, Output, EventEmitter, ChangeDetectionStrategy } from '@angular/core'
import { MediaRootMini, MediaFileMini } from 'elements-sdk'
import { MediaPermissionsService } from 'media/services/mediaPermissions.service'
import { coerceMediaFile, coerceMediaRoot } from 'media/migration'

@Component({
  selector: 'media-breadcrumbs',
  templateUrl: './mediaBreadcrumbs.component.pug',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MediaBreadcrumbsComponent {
  @Input() root: MediaRootMini | null
  @Input() file: MediaFileMini | null
  @Input() text: string
  @Input() isFlat = false
  @Input() disableLinks = false
  @Output() dblclick = new EventEmitter()

  crumbs: {
    name: string,
    link: string,
    disabled?: boolean,
  }[] = []

  constructor (
    private translate: TranslateService,
    private mediaPermissions: MediaPermissionsService,
  ) { }

  ngOnChanges () {
    this.crumbs = []

    if (this.file) {
      this.file = coerceMediaFile(this.file)
    }
    if (this.root) {
      this.root = coerceMediaRoot(this.root)
    }

    if (this.file && this.root) {
      let f = this.file
      while (true) {
        if (!this.mediaPermissions.getPermissionForFile(f)) {
          break
        }
        let isRoot = false
        if (this.root.path === f.path) {
          isRoot = true
        }
        if (isRoot) {
          break
        }
        const browsePath = this.isFlat ? '/media/browse/flat' : '/media/browse'
        this.crumbs.splice(0, 0, {
          name: f.name,
          link: f.isDir ? `${browsePath}/${this.root.id}/${f.id}` : `/media/view/file/${this.root.id}/${f.id}`,
        })
        if (!f.parentFile) {
          break
        }
        f = f.parentFile as unknown as MediaFileMini
        if ('parent_file' in f) {
          f = coerceMediaFile(f)
        }
      }
    }

    if (this.root) {
      this.crumbs.splice(0, 0, {
        name: this.root.name,
        link: `/media/browse/path/${this.root.id}`,
        disabled: !this.mediaPermissions.getPermissionForPath(this.root.fullPath),
      })
    } else {
      this.crumbs.splice(0, 0, {
        name: this.translate.instant('Media Library'),
        link: '/media',
      })
    }
  }
}
